module.exports = __webpack_public_path__ + "static/media/insta.131faa7a.svg";